module.exports = __webpack_public_path__ + "media/components/Marketing/Root/Images/Section5/Product-c1b764260692e827063b7f0c4d0b8c70.svg";